import { render, staticRenderFns } from "./StickyFooter.vue?vue&type=template&id=5248daba&scoped=true"
import script from "./StickyFooter.vue?vue&type=script&lang=js"
export * from "./StickyFooter.vue?vue&type=script&lang=js"
import style0 from "./StickyFooter.vue?vue&type=style&index=0&id=5248daba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5248daba",
  null
  
)

export default component.exports